import { Counter } from './Counter';
import { Type } from 'class-transformer';

export class CounterData {
  private readonly id!: number;

  private readonly value!: number;

  @Type(() => Date)
  private readonly timestamp!: Date;

  @Type(() => Counter)
  private readonly counter!: Counter;

  public getId(): number {
    return this.id;
  }

  public getValue(): number {
    return this.value;
  }

  public getCounter(): Counter {
    return this.counter;
  }

  public getTimestamp(): Date {
    return this.timestamp;
  }
}
